export default __webpack_public_path__ + "static/media/landing-mobile-02.6443f854.png";